import { render, staticRenderFns } from "./ShowInfocardModal.vue?vue&type=template&id=0fa2ef84&scoped=true&"
import script from "./ShowInfocardModal.vue?vue&type=script&lang=js&"
export * from "./ShowInfocardModal.vue?vue&type=script&lang=js&"
import style0 from "./ShowInfocardModal.vue?vue&type=style&index=0&id=0fa2ef84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa2ef84",
  null
  
)

export default component.exports